import styled from 'styled-components';

import Button from 'components/shared/Button';
import StandardModal, { Actions } from 'components/shared/StandardModal';
import { Body, BodySmallBold } from 'styles/typography';

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
  isDismissing: boolean;
}

// Confirms a dismissal before it releases the referral. Says what stays possible afterwards, because
// there is no Undo: running the check again or documenting benefits by hand is the way back.
export default function DismissConfirmModal({ onConfirm, onCancel, isDismissing }: Props) {
  return (
    <StandardModal title='Dismiss Benefit Verification?' onCancel={onCancel} maxWidth='560px'>
      <Content>
        <BodySmallBold>The secondary insurance will no longer hold this referral as needing attention.</BodySmallBold>
        <Body>
          Any results already returned stay visible. You can still re-run the benefit verification or add benefits
          manually for this insurance later.
        </Body>

        <Actions>
          <Button variant='ghost' onClick={onCancel} data-testid='dismiss-benefits-cancel'>
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isDismissing}
            loading={isDismissing}
            data-testid='dismiss-benefits-confirm'>
            Dismiss
          </Button>
        </Actions>
      </Content>
    </StandardModal>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
`;
